import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    &,
    &:before,
    &:after {
      box-sizing: inherit;
    }
    background: ${props => props.background};
  }
  :focus {
    outline: 0;
  }
  ul {
    list-style: none;
  }
  strong {
    font-weight: ${props => props.theme.font.weight.bold};
  }
  /* Layout */
  html {
    box-sizing: border-box;
    font-size: ${props => props.theme.font.scale};
    /* font-family: ${props =>
      props.theme.locale.dir === "rtl" ? (props.isOnPS4 ? `sans-serif` : "URW Geometric Arabic") : "Averta Std PE"}; */
      font-family: ${props => (props.theme.locale.dir === "rtl" ? "URW Geometric Arabic" : "Averta Std PE")};
    /* Changes for html and av-player if player is visible */
    &.isPlayerVisible {
      height: 100%;
      #av-player {
        display: block
      }
    }
  }
  body {
    overflow: hidden;
    /* Changes if player is visible */
    .isPlayerVisible & {
      height: 100%;
      transform: translateZ(0);
      background-color: transparent;
      background-image: none;
    }
    .sansSerifFontFamily {
      font-family: "primary", "secondary", sans-serif;
    }
  }

  .blurred { filter: blur(.45rem); }
`;
